<template>
    
  <!--Drawer-->
  <v-navigation-drawer app v-model="drawer">
    
    <!--Links-->
    <v-list lines="two">
      <v-list-item
        v-for="link in links"
        :href="link.href"
        :key="link.title"
        :title="link.title"
      >
        <template v-slot:prepend>
          <v-icon>{{link.icon}}</v-icon>
        </template>
      </v-list-item>                  
    </v-list>
  </v-navigation-drawer>


  <!--App bar-->
  <v-app-bar>
    <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
    <v-spacer></v-spacer>

    <span class="text-primary text-h5 font-weight-bold" style="font-family: 'Fraunces', Georgia, serif;">Resonaro</span>

    <v-spacer></v-spacer>
    
    <v-btn @click="toggleDarkTheme" icon>
      <v-icon>{{ isDark ? 'mdi-white-balance-sunny' : 'mdi-moon-waning-crescent' }}</v-icon>
    </v-btn>

    <v-btn v-if="!isLoginPage" variant="tonal" @click="signAction">
      <template v-if="isLoggedIn">
        <v-icon start>mdi-login</v-icon>
        <span class="text-none">{{ $t('publicNavbar.access_account') }}</span>
      </template>
      <template v-else>
        <v-icon start>mdi-login</v-icon>
        <span class="text-none">{{ $t('publicNavbar.sign_in') }}</span>
      </template>
    </v-btn>
  </v-app-bar >


</template>

<script>
import { useTheme } from 'vuetify'

export default {
  name: 'ClientNavBar',

  data() {
    return {
      drawer: false,
    }
  },  

  created() {
    this.theme = useTheme()
  },

  mounted() {
    // this.store.initAuth();
  },

  computed: {
    links() {
      return [
        // { title: 'Welcome', icon: 'mdi-home', to: '/', "protected": false },
        {
          title: this.$t('publicNavbar.about'),
          icon: 'mdi-home-outline',
          href: `${process.env.VUE_APP_API_PROTOCOL}://${process.env.VUE_APP_API_HOST}:${process.env.VUE_APP_API_PORT}/`,
          "protected": false
        },
      ];
    },

    filteredLinks() {
      return this.links.filter(link => {
        if (link.protected && !this.store.isLoggedIn) {
          return false;
        }
        return true;
      });
    },

    isLoggedIn() {
      return this.store.isLoggedIn;
    },

    firstName() {
      return this.store.user?.firstName || '';
    },

    lastName() {
      return this.store.user?.lastName || '';
    },  

    role() {
      return this.store.user?.role || 'guest';
    },  

    isDark() {
      return this.store.darkTheme  // Read directly from store
    },

    isLoginPage() {
      return this.$route.path === '/login';
    },
  },

  methods: {
    signAction() {
      // if (this.isLoggedIn) {
      //   this.store.logout();
      //   apiService.clearToken()
      //   this.$router.push('/');
      // } else {
        this.$router.push('/login');
      // }
    },

    toggleDarkTheme() {
      this.store.setDarkTheme(!this.store.darkTheme);
    },
  }
}
</script>

<style scoped>
/**This forces the text not to be shrunk*/
.full-title{
  flex: none;
}
</style>